import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const authHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

// 📄 Obtener gastos de un documento
export const getExpenseItems = async (documentId) => {
  const res = await axios.get(
    `${API_URL}/api/expense-items/document/${documentId}`,
    { headers: authHeaders() }
  );
  return res.data;
};

// ➕ Crear gasto
export const createExpenseItem = async (data) => {
  const res = await axios.post(`${API_URL}/api/expense-items`, data, {
    headers: authHeaders(),
  });
  return res.data;
};

// 🗑 Eliminar gasto
export const deleteExpenseItem = async (id) => {
  await axios.delete(`${API_URL}/api/expense-items/${id}`, {
    headers: authHeaders(),
  });
};

// ✏️ Actualizar gasto
export const updateExpenseItem = async (id, data) => {
  const res = await axios.put(`${API_URL}/api/expense-items/${id}`, data, {
    headers: authHeaders(),
  });
  return res.data;
};
